import { Label } from "@monsterindia/global-ui-components";
import {
  Control,
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormResetField,
  UseFormSetValue,
} from "react-hook-form";

import { CheckboxOptionType, DropdownOptionType } from "../../../types";
import { SingleDropDownController } from "../../controllers";

type BoardFieldsProps = {
  control: Control<FieldValues, any>;
  errors: FieldErrors<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  register: UseFormRegister<FieldValues>;
  resetField: UseFormResetField<FieldValues>;
  clearErrors: (field: string) => void;

  boardData: CheckboxOptionType[] | null;
  mediumData: CheckboxOptionType[] | null;
  percentageData: DropdownOptionType[];
  boardDropdownOptionsHandler: (inputText: string) => void;
  mediumDropdownOptionsHandler: (inputText: string) => void;
  showPercentage?: boolean;
  isDropdownOptionLoading: boolean;
};

export const BoardFields = ({
  control,
  clearErrors,
  errors,
  setValue,
  resetField,
  boardData,
  mediumData,
  boardDropdownOptionsHandler,
  mediumDropdownOptionsHandler,
  percentageData,
  showPercentage,
  isDropdownOptionLoading,
}: BoardFieldsProps) => {
  return (
    <>
      <Label
        labelText="Board"
        isRequired={true}
        className="!l1-text-sm"
        htmlFor="board"
      >
        <SingleDropDownController
          name="board"
          control={control}
          isRequired={true}
          placeholder="Select your board"
          isSearchable={true}
          options={boardData ?? []}
          isLoading={isDropdownOptionLoading}
          // onChangeHandler={(inputText: string) => {
          //   boardDropdownOptionsHandler(inputText);
          // }}
          onSelect={(value: DropdownOptionType) => {
            clearErrors("board");
            setValue("board", value);
            // resetField("medium");
            // resetField("percentage");
          }}
          errorMessage={errors.board ? "This field is required" : ""}
        />
      </Label>

      <Label labelText="Medium" isRequired={true} className="!l1-text-sm">
        <SingleDropDownController
          name="medium"
          control={control}
          isRequired={true}
          placeholder="Select your medium"
          isSearchable={true}
          options={mediumData ?? []}
          isLoading={isDropdownOptionLoading}
          onChangeHandler={(inputText: string) => {
            mediumDropdownOptionsHandler(inputText);
          }}
          onSelect={(value: DropdownOptionType) => {
            clearErrors("medium");
            setValue("medium", value);
            // resetField("percentage");
          }}
          errorMessage={errors.medium ? "This field is required" : ""}
        />
      </Label>

      {showPercentage && (
        <Label labelText="Percentage" isRequired={true} className="!l1-text-sm">
          <SingleDropDownController
            name="percentage"
            control={control}
            isRequired={true}
            placeholder="Select your percentage"
            isSearchable={false}
            options={percentageData}
            isLoading={isDropdownOptionLoading}
            onSelect={(value: DropdownOptionType) => {
              clearErrors("percentage");
              setValue("percentage", value);
            }}
            errorMessage={errors.percentage ? "This field is required" : ""}
          />
        </Label>
      )}
    </>
  );
};
